import { Context } from '@leverege/plugin';
import { Dialogs } from '@leverege/ui-elements';
import I18N from '@leverege/i18n';
import RemoveApiAccessKeysDialog from "../apiAccessKey/RemoveApiAccessKeysDialog.js";
const {
  t,
  tf,
  tIcon
} = I18N.ns('apiAccessKeyManagement.action.RemoveApiAccessKey');
export default {
  id: 'apiAccessKeyManagement.action.RemoveApiAccessKey',
  type: 'ApiAccessKeys.remove',
  name: tf('name'),
  layout: {
    sort: 'accessManagement.c',
    // presence of '.' causes section grouping behavior
    sectionName: 'Access Management'
  },
  matches: {
    use: 'contextMenu',
    client: 'ApiAccessKeys'
  },
  prepare: async context => {
    const {
      clientProps: {
        actions,
        dispatch
      }
    } = context;
    const targets = Context.getTargetsOfType(context, 'apiAccessKey');
    if (targets?.length) {
      return dispatch(actions.apiAccessKey(targets[0]).canDelete());
    }
    return null;
  },
  isPrepared: context => {
    const {
      clientProps: {
        allowed
      }
    } = context;
    const targets = Context.getTargetsOfType(context, 'apiAccessKey');
    if (!targets?.length) {
      return true;
    }
    return typeof allowed.deleteApiAccessKey === 'boolean';
  },
  handles: context => {
    const {
      clientProps: {
        allowed
      }
    } = context;
    return allowed.deleteApiAccessKey === true && Context.hasTargetsOfType(context, 'apiAccessKey');
  },
  appearance: opts => {
    const {
      context
    } = opts;
    const targets = Context.getTargetsOfType(context, 'apiAccessKey');
    const name = t('appearanceName', {
      count: targets.length
    });
    const icon = tIcon('trash', '@icon:trash');
    return {
      name,
      icon
    };
  },
  perform: ({
    context
  }) => {
    const targets = Context.getTargetsOfType(context, 'apiAccessKey');
    const {
      resourceId,
      clientProps: {
        actions,
        dispatch
      },
      uiName
    } = context;
    Dialogs.show({
      component: RemoveApiAccessKeysDialog,
      props: {
        resourceId,
        actions,
        targets,
        dispatch,
        uiName
      }
    });
  }
};